import React from "react";
import { CircleFlag } from "../../common/CircleFlag";
import CountryDict from "../../utils/countryDict";
import { GroupTableData } from "../../types/GroupTableData";
import { handleName } from "../../utils/handleName";
import "./FixtureStyles.scss";

interface GroupTableProps {
  groupTableData: GroupTableData[];
  isDesktop?: boolean;
}

// The top two teams of each group advance to the knockout stage.
const QUALIFY_CUTOFF = 2;

const GroupTable: React.FC<GroupTableProps> = ({
  groupTableData,
  isDesktop,
}) => {
  const flagSize = isDesktop ? 30 : 24;

  return (
    <div className={`groupTable${isDesktop ? " groupTable--desktop" : ""}`}>
      <div className="groupTable__header">
        <span className="groupTable__pos">#</span>
        <span className="groupTable__teamHead">Country</span>
        <span className="groupTable__stat groupTable__stat--pts">Pts</span>
        <span className="groupTable__stat">W</span>
        <span className="groupTable__stat">D</span>
        <span className="groupTable__stat">L</span>
      </div>

      {groupTableData.map((data, index) => {
        const name = data.team.internationalName;
        const qualifies = index < QUALIFY_CUTOFF;
        return (
          <div
            key={`${name}-row-${index}`}
            className={`groupTable__row${
              qualifies ? " groupTable__row--qualify" : ""
            }`}
          >
            <span className="groupTable__pos">{index + 1}</span>
            <span className="groupTable__team">
              <span className="groupTable__flag">
                <CircleFlag
                  countryCode={CountryDict.get(name) || "pl"}
                  height={flagSize}
                  width={flagSize}
                />
              </span>
              <span className="groupTable__name">
                {isDesktop ? name : handleName(name)}
              </span>
            </span>
            <span className="groupTable__stat groupTable__stat--pts">
              {data.points}
            </span>
            <span className="groupTable__stat">{data.wins}</span>
            <span className="groupTable__stat">{data.draws}</span>
            <span className="groupTable__stat">{data.lost}</span>
          </div>
        );
      })}
    </div>
  );
};

export default GroupTable;
